module.exports = __webpack_public_path__ + "static/media/mech-victory-v3.b9ab68d2.png";